<template>
  <v-card id="read-list">
    <v-card-title class="pa-0">
      <div class="modal-header width-100">
        <v-toolbar flat color="primary" dark :class="{'px-5': !$store.state.isSp}">

          <v-toolbar-title>
            <span id="read-list-screen-title" class="font-large-s font-bold font-color-primary-btn-text">重要なお知らせ</span>
          </v-toolbar-title>

          <v-btn id="read-list-close-btn" icon variant="text" @click="$emit('close')"><v-icon size="36px" color="primaryBtnText">mdi-close</v-icon></v-btn>
        </v-toolbar>
      </div>
    </v-card-title>

    <v-card-text class="px-4">
      <div>
        <div><h2 class="my-6">ＪリーグIDメンテナンスのお知らせ（2020年8月24日・25日)</h2></div>
        <div>
          <p class="mb-4">平素はＪリーグチケットをご利用いただきありがとうございます。<br>このたびサービス向上のため、ＪリーグIDシステムメンテナンスを実施いたします。<br>また下記時間帯のメンテナンス対応以降、該当のサービスをご利用の際に、ＪリーグIDおよびパスワードの入力が再度必要になります。<br>お客さまには大変ご迷惑をおかけいたしますが、何卒ご了承いただけますようよろしくお願い申し上げます。<br>※事前にログインに必要な情報をご確認いただくことをおすすめいたします。</p>
        </div>
        <v-divider class="my-4"></v-divider>
        <div>
          <h4 class="font-bold pb-2">メンテナンス日時</h4>
          <p class="mb-4">・2020年08月24日（月）00:00-24:00（終日）<br>ＪリーグIDの登録情報の変更等ができません。<br>※なおメンテナンスは多少時間帯が前後する可能性があります。</p>
        </div>
        <v-divider class="my-4"></v-divider>
        <div>
          <h4 class="font-bold pb-2">システムメンテナンス期間にご利用いただけなくなるサービス</h4>
          <p class="mb-4">・Ｊリーグチケットサイトの閲覧<br>・購入履歴の閲覧<br>・チケット申し込み<br>・ＪリーグIDの新規登録、登録内容の変更、退会<br>・ワンタッチパス紐づけ登録<br><br>※システムメンテナンス期間以前にすでにお申し込み済みのチケットは、店頭での発券は可能です。</p>
        </div>
        <v-divider class="my-4"></v-divider>
        <div>
          <p class="mb-4">ご利用の皆さまには大変ご迷惑をお掛けいたしますが、何卒よろしくお願い申し上げます。<br><br>2020年8月18日</p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
